"use client";

export default function UserIcon({ className = "", ...props }) {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}
      {...props}>
<path d="M20.27 20.27C24.757 20.27 28.3944 16.6326 28.3944 12.1456C28.3944 7.65863 24.757 4.02121 20.27 4.02121C15.783 4.02121 12.1456 7.65863 12.1456 12.1456C12.1456 16.6326 15.783 20.27 20.27 20.27Z" stroke="currentColor" strokeWidth="2.5629" strokeMiterlimit="10" strokeLinecap="round"/>
<path d="M4.0191 36.5209C4.0191 27.5465 11.2956 20.27 20.27 20.27C29.2445 20.27 36.521 27.5465 36.521 36.5209" stroke="currentColor" strokeWidth="2.5629" strokeMiterlimit="10"/>
</svg>
  );
}



